import React, { useState } from 'react';
import { COLORS, getColorByValue } from '../data/colors';

interface ColorSelectorProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
}

const ColorSelector: React.FC<ColorSelectorProps> = ({ 
  value, 
  onChange, 
  label, 
  placeholder = "Sélectionner une couleur" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedColor = getColorByValue(value);

  const handleColorSelect = (colorValue: string) => {
    onChange(colorValue);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full bg-white border border-gray-300 rounded-md px-3 py-2 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            {selectedColor && (
              <div 
                className="w-4 h-4 rounded-full mr-3 border border-gray-300"
                style={{ backgroundColor: selectedColor.color }}
                aria-hidden="true"
              />
            )}
            <span className="text-sm text-gray-700">
              {selectedColor ? selectedColor.label : placeholder}
            </span>
          </div>
          <svg 
            className={`w-5 h-5 text-gray-400 transition-transform ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>

      {isOpen && (
        <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg">
          <div className="p-2">
            <div className="max-h-48 overflow-y-auto">
              {COLORS.map((color) => (
                <button
                  key={color.value}
                  type="button"
                  onClick={() => handleColorSelect(color.value)}
                  className="w-full flex items-center px-3 py-2 text-left hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
                  style={{ 
                    backgroundColor: color.value === value ? '#f3f4f6' : 'transparent' 
                  }}
                >
                  <div 
                    className="w-4 h-4 rounded-full mr-3 border border-gray-300 flex-shrink-0"
                    style={{ backgroundColor: color.color }}
                    aria-hidden="true"
                  />
                  <span className="text-sm font-medium text-gray-900">
                    {color.label}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorSelector;
